import { useAuth0 } from '@auth0/auth0-react'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { HealthProgramStatisticsResponse, ScreeningInsightsResponse } from '@estercare/ester-shared'
import { QueryKeys } from '../../types'
import { getHealthProgramStatistics, getScreeningInsights, getTestimonials } from './analytics'
import { TestimonialsResponse } from './types'

export const useGetHealthProgramStatistics = (): UseQueryResult<HealthProgramStatisticsResponse, Error> => {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: [QueryKeys.HealthProgramStatistics, 'private'],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getHealthProgramStatistics({ accessToken })
    },
  })
}

export const useGetScreeningInsights = (): UseQueryResult<ScreeningInsightsResponse, Error> => {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: [QueryKeys.ScreeningInsights, 'private'],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getScreeningInsights({ accessToken })
    },
  })
}

export const useGetTestimonials = (): UseQueryResult<TestimonialsResponse, Error> => {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: [QueryKeys.Testimonials, 'private'],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getTestimonials({ accessToken })
    },
  })
}
